import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { PlanData } from "types/models/planMaster/planMasterApp";
import { isModuleAuthorized } from "@crema/utility/Utils";

interface OrderActionsProps {
  data: PlanData;
}

const OrderActions: React.FC<OrderActionsProps> = ({ data }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/planMaster/viewPlan/planUpdate/${data.planId}`);
  };

  return (
    <Box>
      {isModuleAuthorized("Edit Plan") ? (
        <IconButton onClick={handleEdit}>
          <EditIcon style={{ fontSize: 24 }} />
        </IconButton>
      ) : (
        <Tooltip title="You don't have permission to edit">
          <span>
            <IconButton disabled>
              <EditIcon style={{ fontSize: 24, opacity: 0.5 }} />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default OrderActions;
